import { render, staticRenderFns } from "./WidgetCounter.vue?vue&type=template&id=a6c20e70&scoped=true"
import script from "./WidgetCounter.vue?vue&type=script&lang=js"
export * from "./WidgetCounter.vue?vue&type=script&lang=js"
import style0 from "./WidgetCounter.vue?vue&type=style&index=0&id=a6c20e70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6c20e70",
  null
  
)

export default component.exports